import { Address } from "./address.model";

export class BusinessInformationModel {
    constructor(
    public OperatingName : string = '',
    public LegalName: string = '' ,
    public BusinessNumber: string = '',
    public BusinessType: string = '',
    public WSIBAccountNumber: string = '',
    public PrimaryAddress: Address = new Address('','','','','','','',''),
    public CompanyWebSite:string = '',
    public CorrespondenceOption: string = '',
    public CorrespondenceOptionValue: string|null = '',
    public isMailingAndBusinessAddressSame?: boolean,
    public ApplicantBusinessId?: string,
    public PrimaryAddressId?: string,
    public CompanyWebsiteId?: string,
    public isValidBN9? :boolean ,
    public PhoneNumber: string = ''
    ){}

}